/**
 * Стили ячеек Excel (используются xlsx-js-style).
 * Один источник правды — чтобы цвета/бордеры легко менять централизованно.
 */

const THIN_BORDER = { style: 'thin', color: { rgb: 'B0B0B0' } } as const;

const BORDER_ALL = {
  top: THIN_BORDER,
  bottom: THIN_BORDER,
  left: THIN_BORDER,
  right: THIN_BORDER,
} as const;

export const HEADER_STYLE = {
  font: { bold: true, color: { rgb: '1F1F1F' } },
  alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  fill: { patternType: 'solid', fgColor: { rgb: 'F0F2F5' } },
  border: BORDER_ALL,
} as const;

export const ROW_HEADER_STYLE = {
  font: { bold: true, color: { rgb: '595959' } },
  alignment: { horizontal: 'center', vertical: 'center' },
  fill: { patternType: 'solid', fgColor: { rgb: 'FAFAFA' } },
  border: BORDER_ALL,
} as const;

export const DATA_STYLE = {
  alignment: { vertical: 'center' },
  border: BORDER_ALL,
} as const;

/** Превращает '#9333ea' / '9333EA' / '9333ea' → 'RGB' формат для xlsx-js-style. */
export function toExcelRgb(hex: string): string | undefined {
  const cleaned = hex.replace(/^#/, '').trim().toUpperCase();
  if (!/^[0-9A-F]{6}$/.test(cleaned)) return undefined;
  return cleaned;
}

/** Стиль шапки с пользовательской заливкой (повторяет UI: белый текст, bold). */
export function coloredHeaderStyle(hex: string) {
  const rgb = toExcelRgb(hex);
  if (!rgb) return HEADER_STYLE;
  return {
    font: { bold: true, color: { rgb: 'FFFFFF' } },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    fill: { patternType: 'solid', fgColor: { rgb } },
    border: BORDER_ALL,
  };
}
